import React from 'react'
import { Box, Chip, Typography } from '@mui/material'

/** A campaign's point total. A dash until the value arrives, which a 0 would misreport. */
export const TotalPoints = ({ value }) => (
  <Box sx={{ textAlign: 'center', mt: 1, mb: 3 }}>
    <Typography variant='overline' color='text.secondary' display='block'>
      Total Points
    </Typography>
    <Chip
      label={value?.toLocaleString() ?? '—'}
      sx={{ height: 36, px: 1, fontSize: '1.25rem', fontWeight: 500, bgcolor: 'whitesmoke' }}
    />
  </Box>
)
